import React from 'react';
import { useClub } from '../../contexts/ClubContext';

const ClubHeader = ({ isMobile }) => {
  const { club } = useClub();

  return null;
};

export default ClubHeader;